
import axios from 'axios';

// const API_URL = "http://127.0.0.1:8000/api";
// const User_API_URL = "http://127.0.0.1:8000/api";
// const API_Branch = "http://127.0.0.1:8000/api/branchlogin";
// const API_Branchs = "http://127.0.0.1:8000/api/branchlogin";
// const API_Student = "http://127.0.0.1:8000/api/student";
// const API_URL_Image = "http://127.0.0.1:8000/storage";
// const API_BASE_URL = "http://localhost:8000/api";


const API_URL = "https://rrkmicrofinance.in/software/api";
const User_API_URL = "https://rrkmicrofinance.in/software/api";
const API_Branch = "https://rrkmicrofinance.in/software/api/branchlogin";
const API_Branchs = "https://rrkmicrofinance.in/software/api/branchlogin";
const API_Student = "https://rrkmicrofinance.in/software/api/student";
const API_URL_Image = "https://rrkmicrofinance.in/software/storage";
const API_BASE_URL = "https://rrkmicrofinance.in/software/api";

// const API_URL = "https://rrkmicrofinance.in/soft/api";
// const User_API_URL = "https://rrkmicrofinance.in/soft/api";
// const API_Branch = "https://rrkmicrofinance.in/soft/api/branchlogin";
// const API_Branchs = "https://rrkmicrofinance.in/soft/api/branchlogin";
// const API_Student = "https://rrkmicrofinance.in/soft/api/student";
// const API_URL_Image = "https://rrkmicrofinance.in/soft/storage";
// const API_BASE_URL = "https://rrkmicrofinance.in/soft/api";

// const API_URL= "https://harpurcare.in/crm/api";
// const API_BASE_URL = "https://harpurcare.in/crm/api"; // Adjust as per your Laravel backend URL
// const API_URL_Image= "https://harpurcare.in/crm/storage";
const token = localStorage.getItem("token"); // Ensure token is available

// Function to save account details
export const saveAccountDetails = async (formData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/accounts`, formData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
};
export { API_URL, API_URL_Image, API_Branch, User_API_URL, API_Student, API_Branchs }
